module.exports = __webpack_public_path__ + "static/media/TN-Women-Tops-2.0.893965db.svg";